import { createApp } from "vue";
import StudentStaleGroupAssignments from "./components/StudentStaleGroupAssignments.vue";
import { getMountElements, readPayload, VUE_MOUNTED_ATTRIBUTE } from "./utils/vueMount";

export function initStudentStaleGroupAssignmentsApp(root = document) {
  const apps = [];
  for (const element of getMountElements(root, "[data-vue-student-stale-group-assignments]")) {
    if (element.hasAttribute(VUE_MOUNTED_ATTRIBUTE)) {
      continue;
    }
    const payload = readPayload(element);
    const app = createApp(StudentStaleGroupAssignments, {
      apiUrl: payload.apiUrl || "",
      initialAssignments: Array.isArray(payload.initialAssignments) ? payload.initialAssignments : [],
      groupUrlTemplate: payload.groupUrlTemplate || "",
      studentId: Number(payload.studentId) || 0,
      sheetId: Number(payload.sheetId) || 0,
    });
    app.mount(element);
    element.setAttribute(VUE_MOUNTED_ATTRIBUTE, "1");
    apps.push(app);
  }
  return apps;
}
